import { doGet, doPut, doPost } from "../base";

const USERS_URL = '/user_auth/users';
const PERMISSIONS_URL = '/user_auth/permissions';

const SET_DAFAULTS = ({ limit, offset, sort }) => {
    let params = [];
    if (limit && limit !== null) {
        params.push("limit=" + limit);
    }
    if (offset && offset !== null) {
        params.push("offset=" + offset);
    }
    if (sort && sort !== null) {
        params.push("sort=" + sort);
    }

    return params;
}

export const getUsers = async ({ email = "", userId = "", clientId = "", showInactive = false, limit, offset, sort }) => {
    var url = USERS_URL;

    if (userId !== "") url += "/" + userId;

    let params = SET_DAFAULTS({ limit, offset, sort });
    if (email !== "") params.push("email=" + email);
    if (clientId !== "") params.push("clientId=" + clientId);
    if (showInactive !== "") params.push("showInactive=" + showInactive);

    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const getUserForCreation = async ({ email = "", clientId = "" }) => {
    var url = USERS_URL + "/creation";

    let params = [];
    if (email !== "") params.push("email=" + email);
    if (clientId !== "") params.push("clientId=" + clientId);

    for (let i = 0; i < params.length; i++) {
        url += i > 0 ? "&" + params[i] : "?" + params[i];
    }

    return await doGet(url).catch((error) => {
        throw error;
    });
};

export const postUser = async ({ user, clientId }) => {
    const body = { ...user, clientId };

    return await doPost(body, USERS_URL).catch((error) => {
        throw error;
    })
}

export const putUser = async ({ user, clientId }) => {
    var url = USERS_URL + "/" + user.userId;
    const body = { ...user, clientId };

    return await doPut(body, url).catch((error) => {
        throw error;
    })
}

export const getFacilities = async({ parentId }) => {
    var url = USERS_URL + "/facilities";
    if (!parentId) throw new Error("parentId cannot be null.");

    return await doGet(url + "?parentId=" + parentId).catch((error) => {
        throw error;
    });
}

export const getAllPermissions = async ({ scope }) => {
    return await doGet(PERMISSIONS_URL).catch((error) => { 
        throw error;
    });
}

export const getUser = async (userId, { limit, offset, sort }) => {

    if (!userId || userId === null) {
        throw new Error("Device Id cannot be null.");
    }

    return {}
};
